import Box from '@mui/material/Box'
import { cdnImage } from '../../config/env'

export default function FarmerGroupImage() {
  return (
    <Box
      component="img"
      src={cdnImage('15-farming-group_3.png')}
      alt="Group of people gathered in a farming landscape"
      loading="eager"
      sx={{
        width: '100%',
        height: 'auto',
        maxWidth: { xs: 360, md: 420 },
        objectFit: 'cover',
        display: 'block',
      }}
    />
  )
}
